import { render, staticRenderFns } from "./advanced-option.vue?vue&type=template&id=13952480"
import script from "./advanced-option.vue?vue&type=script&lang=js"
export * from "./advanced-option.vue?vue&type=script&lang=js"
import style0 from "./advanced-option.vue?vue&type=style&index=0&id=13952480&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports